import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from './services/data.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'bioseq-ui';
  loading: boolean = false;

  constructor(private router: Router){}

  goHome(){
    this.router.navigate(['run-list']);
  }
}
